import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _fillInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/fill';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React, { memo } from 'react';

var _excluded = ["fill", "fill2"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function IcInputDelete(customProps) {
  var fill = _fillInstanceProperty(customProps),
    fill2 = customProps.fill2,
    props = _objectWithoutProperties(customProps, _excluded);
  return /*#__PURE__*/React.createElement("svg", _objectSpread({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: fill2 || '#929294'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11729 7.11729C7.4514 6.78317 7.99311 6.78317 8.32722 7.11729L16.8828 15.6728C17.2169 16.007 17.2169 16.5487 16.8828 16.8828C16.5487 17.2169 16.007 17.2169 15.6728 16.8828L7.11729 8.32722C6.78317 7.99311 6.78317 7.4514 7.11729 7.11729Z",
    fill: fill || 'white'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11729 16.8827C6.78317 16.5486 6.78317 16.0069 7.11729 15.6728L15.6728 7.11722C16.007 6.7831 16.5487 6.7831 16.8828 7.11722C17.2169 7.45134 17.2169 7.99304 16.8828 8.32716L8.32722 16.8827C7.99311 17.2168 7.4514 17.2168 7.11729 16.8827Z",
    fill: fill || 'white'
  }));
}
var IcInputDelete$1 = /*#__PURE__*/memo(IcInputDelete);

export { IcInputDelete$1 as default };
